import { render, staticRenderFns } from "./UiUrlLinker.vue?vue&type=template&id=49a918ec&scoped=true"
import script from "./UiUrlLinker.vue?vue&type=script&lang=js"
export * from "./UiUrlLinker.vue?vue&type=script&lang=js"
import style0 from "./UiUrlLinker.vue?vue&type=style&index=0&id=49a918ec&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a918ec",
  null
  
)

export default component.exports